// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useGlobalState } from './globalState/GlobalStateProvider';
import { mobileView } from './api/utility';

const Rot = keyframes`
    0% {    transform: rotate(0deg); }
    30% {   transform: rotate(360deg); }
    50% {   transform: rotate(360deg); }
    80% {   transform: rotate(0deg); }
    100% {  transform: rotate(0deg); }
`;
const ToBig = keyframes`
    0% {    transform: scale(1) translateX(0px); }
    30% {   transform: scale(1) translateX(0px); }
    50% {   transform: scale(10) translateX(-4.5px); }
    80% {   transform: scale(10) translateX(-4.5px); }
    100% {  transform: scale(1) translateX(0px); }
`;
const ToBig2 = keyframes`
    0% {    transform: scale(1) translateX(0px); }
    30% {   transform: scale(1) translateX(0px); }
    50% {   transform: scale(10) translateX(4.5px); }
    80% {   transform: scale(10) translateX(4.5px); }
    100% {  transform: scale(1) translateX(0px); }
`;
const Breath = keyframes`
    0% {   transform: scale(1); }
    25% {   transform: scale(1); }
    40% {   transform: scale(1.1); }
    50% {   transform: scale(1); }
    75% {   transform: scale(1); }
    90% {   transform: scale(1.1); }
`;
const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    // padding: 1em;
    opacity: 0;
    animation: fadeIn 2s;
    animation-fill-mode: forwards;
`;
const Loader = styled.svg`
    max-width: 200px;
    max-height: 100%;
    margin: 1em;
    transform-origin:50% 50%;
    overflow:visible;
`;
const CI1 = styled.circle`
    fill: ${({ theme, mobile }) => mobile ? theme.mobile.primary : theme.body};
    animation: ${ToBig} 3s infinite -1.5s;
    transform-box: fill-box;
    transform-origin:50% 50%;
`;
const CIW = styled.circle`
    transform-box: fill-box;
    transform-origin: 50% 50%;
    animation: ${Breath} 3s infinite;
    fill: ${({ theme, mobile }) => mobile ? theme.mobile.tertiary : theme.tertiary};
`;
const CI2 = styled.circle`
    fill: ${({ theme, mobile }) => mobile ? theme.mobile.secondary : theme.secondary};
    animation: ${ToBig2} 3s infinite;
    transform-box: fill-box;
    transform-origin: 50% 50%;
`;
const Points = styled.g`
    animation: ${Rot} 3s infinite;
    transform-box: fill-box;
    transform-origin: 50% 50%;
`;

const Loading = ({ ...props }) => {
    const {
        state: {
            // mobileView,
        },
    } = useGlobalState();

    return (
        <Wrapper>
            <Loader viewBox="0 0 100 100">
                <Points>
                    <CIW cx="50" cy="50" r="50" fill="#fff" mobile={mobileView} />
                    <CI2 cx="5" cy="50" r="4" mobile={mobileView} />
                    <CI1 cx="95" cy="50" r="4" mobile={mobileView} />
                </Points>
            </Loader>
        </Wrapper>
    );
}

export default Loading;
